import React from 'react';
import { Container } from 'reactstrap';

export default class Page404 extends React.Component {
    render() {
        const ele = document.getElementById('ipl-progress-indicator');
        if(ele){
            ele.classList.add('available');
            setTimeout(() => {
                ele.remove();
            }, 2000)
        };
        return (
            <>
                <Container fluid>
                        <main style={{ padding: "1rem" }}>
                            <p>Error 404! There's nothing here!</p>
                            <img src='/images/duck_conf.gif' />
                        </main>
                </Container>
            </>
        );
    }
}